import classNames from "classnames";
import React, { Component } from "react";
import { ButtonProps } from "Shared/Button";
import { SecondaryButton } from "Shared/Buttons";
import { SvgIconProps } from "src/components/icons/SvgIcon";
import PoweredByImage from "src/images/powered-by.inline.svg";
import WaityButton, { WaityButtonProps } from "../../../UserAccount/shared/WaityButton";
import "./MessageModal.scss";

export interface MessageModalProps {
    buttons?: ButtonProps[];
    waityButtons?: WaityButtonProps[];
    icon: React.FunctionComponent<SvgIconProps>;
    logoDisplayed?: boolean;
    message: string | JSX.Element;
    title: string;

    renderFooter?: () => JSX.Element;
}

class MessageModal extends Component<MessageModalProps> {
    public renderLogo(placement: string): JSX.Element | null {
        const { logoDisplayed = true } = this.props;

        return logoDisplayed ? <PoweredByImage className={`MessageModal__${placement}-logo`} /> : null;
    }

    public renderIcon(): JSX.Element | null {
        const { icon: Icon } = this.props;

        return Icon ? <Icon className="MessageModal__header-title-icon" /> : null;
    }

    public render() {
        const { buttons = [], waityButtons = [], message, title } = this.props;

        return (
            <section className="MessageModal__content">
                <header className="MessageModal__header">
                    {this.renderLogo("header")}
                    {this.renderIcon()}
                    <h1 className="MessageModal__header-title">{title}</h1>
                </header>
                <div className="MessageModal__main">
                    <p className="MessageModal__text">{message}</p>
                </div>
                {this.props.children}
                <footer>
                    {buttons.map(({ className, text, ...rest }: ButtonProps, index: number) => (
                        <SecondaryButton className={classNames(className)} {...rest} key={`b-${index}`}>
                            {text}
                        </SecondaryButton>
                    ))}
                    {waityButtons.map((waityButtonProps: WaityButtonProps, index: number) => (
                        <WaityButton {...waityButtonProps} key={`wb-${index}`} />
                    ))}

                    {this.props.renderFooter && this.props.renderFooter()}

                    {this.renderLogo("footer")}
                </footer>
            </section>
        );
    }
}

export default MessageModal;
